import { NoteDTO, ProductDTO, ProductPricingOptionDTO, RestrictionDTO, SubProductDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { AttributeListResult } from 'src/app/shared/components/attribute-list/attribute-list.component';

export enum ProductActionTypes {
    LoadProductDetails = '[Product] LoadProductDetails',
    LoadProductDetailsSuccess = '[Product] LoadProductDetailsSuccess',
    LoadProductDetailsFailure = '[Product] LoadProductDetailsFailure',

    LoadProductsByIds = '[Product] LoadProductsByIds',
    LoadProductsByIdsSuccess = '[Product] LoadProductsByIdsSuccess',

    UpsertProduct = '[Product] UpsertProduct',
    UpsertProductSuccess = '[Product] UpsertProductSuccess',
    UpsertProductFailure = '[Product] UpsertProductFailure',

    ReloadProduct = '[Product] ReloadProduct',
    ReloadProductSuccess = '[Product] ReloadProductSuccess',
    ReloadProductFailure = '[Product] ReloadProductFailure',

    ProductActionFailure = '[Product] ProductActionFailure',
    AddUpdateRemoveProductAttributes = '[Product] AddUpdateRemoveProductAttributes',
    AddUpdateRemoveSubProductAttributes = '[Product] AddUpdateRemoveSubProductAttributes',

    UpsertProductNote = '[Product] UpsertProductNote',
    RemoveProductNote = '[Product] RemoveProductNote',

    UpsertProductAgreement = '[Product] UpsertProductAgreement',
    DeleteProductAgreement = '[Product] DeleteProductAgreement',

    UpsertPricingOption = '[Product] UpsertPricingOption',
    DeletePricingOption = '[Product] DeletePricingOption',
    UpdatePricingOptionsOrder = '[Product] UpdatePricingOptionsOrder',
    UpdatePricingOptionsOrderSuccess = '[Product] UpdatePricingOptionsOrderSuccess',

    UpsertSubProduct = '[Product] UpsertSubProduct',
    AddSubSubProduct = '[Product] AddSubSubProduct',
    UpdateSubProduct = '[Product] UpdateSubProduct',
    RemoveSubProduct = '[Product] RemoveSubProduct',

    UpsertSubProductRestriction = '[Product] UpsertSubProductRestriction',
    RemoveSubProductRestriction = '[Product] RemoveSubProductRestriction',

    UpsertProductAttachment = '[Product] UpsertProductAttachment',
    RemoveProductAttachment = '[Product] RemoveProductAttachment'
}
export const UpsertProductAttachment = createAction(ProductActionTypes.UpsertProductAttachment, props<{ productId: string; file: File }>());
export const RemoveProductAttachment = createAction(
    ProductActionTypes.RemoveProductAttachment,
    props<{ productId: string; documentDescriptionId: string }>()
);

export const UpsertSubProductRestriction = createAction(
    ProductActionTypes.UpsertSubProductRestriction,
    props<{ restriction: RestrictionDTO; productId: string }>()
);
export const RemoveSubProductRestriction = createAction(
    ProductActionTypes.RemoveSubProductRestriction,
    props<{ restrictionId: string; productId: string }>()
);

export const ProductActionFailure = createAction(ProductActionTypes.ProductActionFailure, props<{ error: any }>());

export const UpsertProduct = createAction(ProductActionTypes.UpsertProduct, props<{ product: ProductDTO }>());
export const UpsertProductSuccess = createAction(ProductActionTypes.UpsertProductSuccess, props<{ productId: string }>());
export const UpsertProductFailure = createAction(ProductActionTypes.UpsertProductFailure, props<{ error: any }>());

export const LoadProductDetails = createAction(ProductActionTypes.LoadProductDetails, props<{ productId: string }>());
export const LoadProductDetailsSuccess = createAction(
    ProductActionTypes.LoadProductDetailsSuccess,
    props<{ products: ProductDTO[]; language?: string }>()
);
export const LoadProductDetailsFailure = createAction(ProductActionTypes.LoadProductDetailsFailure, props<{ error: any }>());

// Bulk load without a request state; its result is observed through the loaded entities, a failure through their absence.
export const LoadProductsByIds = createAction(ProductActionTypes.LoadProductsByIds, props<{ productIds: string[] }>());
export const LoadProductsByIdsSuccess = createAction(ProductActionTypes.LoadProductsByIdsSuccess, props<{ products: ProductDTO[] }>());

export const ReloadProduct = createAction(ProductActionTypes.ReloadProduct, props<{ productId: string }>());
export const ReloadProductSuccess = createAction(ProductActionTypes.ReloadProductSuccess, props<{ product: ProductDTO }>());
export const ReloadProductFailure = createAction(ProductActionTypes.ReloadProductFailure, props<{ error: any }>());

export const AddUpdateRemoveProductAttributes = createAction(
    ProductActionTypes.AddUpdateRemoveProductAttributes,
    props<{
        attributeResult: AttributeListResult;
    }>()
);

export const AddUpdateRemoveSubProductAttributes = createAction(
    ProductActionTypes.AddUpdateRemoveSubProductAttributes,
    props<{
        subProduct: SubProductDTO;
        attributeResult: AttributeListResult;
    }>()
);

export const UpsertProductNote = createAction(ProductActionTypes.UpsertProductNote, props<{ note: NoteDTO }>());
export const RemoveProductNote = createAction(ProductActionTypes.RemoveProductNote, props<{ noteId: string }>());

export const UpsertPricingOption = createAction(
    ProductActionTypes.UpsertPricingOption,
    props<{ pricingOption: ProductPricingOptionDTO }>()
);
export const DeletePricingOption = createAction(
    ProductActionTypes.DeletePricingOption,
    props<{ pricingOptionId: string; productId: string }>()
);
export const UpdatePricingOptionsOrder = createAction(
    ProductActionTypes.UpdatePricingOptionsOrder,
    props<{ pricingOptions: ProductPricingOptionDTO[]; productId: string }>()
);
export const UpdatePricingOptionsOrderSuccess = createAction(
    ProductActionTypes.UpdatePricingOptionsOrderSuccess,
    props<{ pricingOptions: ProductPricingOptionDTO[]; productId: string }>()
);

export const UpsertSubProduct = createAction(
    ProductActionTypes.UpsertSubProduct,
    props<{ subProduct: SubProductDTO; productId: string }>()
);
export const AddSubSubProduct = createAction(
    ProductActionTypes.AddSubSubProduct,
    props<{ subProduct: SubProductDTO; productId: string }>()
);
export const RemoveSubProduct = createAction(ProductActionTypes.RemoveSubProduct, props<{ subProductId: string; productId: string }>());
